import { useUpdateEffect } from './useUpdateEffect';
import { SelectedOffsegMasterInfoType } from './useStateSelectedOffsegMasterInfo';

import { MasterInfo } from '../../type/MasterInfoType';
import { DialogType } from '../../type/DialogType';
import { all, offsegGetType } from '../../const/commonConst';
import { getOffsegMasterInfoWithOrganizationIdHandler } from '../../handler/getOffsegMasterInfoWithOrganizationIdHandler';

type InputType = {
	getType: (typeof offsegGetType)[keyof typeof offsegGetType];
	selectedOffsegMasterInfo: SelectedOffsegMasterInfoType;
	setSelectedOffsegMasterInfo: React.Dispatch<React.SetStateAction<SelectedOffsegMasterInfoType>>;
	masterInfo: MasterInfo;
	setMasterInfo: React.Dispatch<React.SetStateAction<MasterInfo>>;
	setDialog: (value: React.SetStateAction<DialogType>) => void;
};

const initSelectedOffsegMasterInfo = {
	selectedOffsegOrganizationInfo: all,
	selectedOffsegCarInfo: all,
	selectedOffsegDriverInfo: all,
};

/**
 * Offsegマスタデータの状態管理用カスタムフック
 */
export const useEffectOffsegMasterInfo = (input: InputType) => {
	const { getType, selectedOffsegMasterInfo, setSelectedOffsegMasterInfo, masterInfo, setMasterInfo, setDialog } = input;

	// Offsegの組織選択後のマスタデータ取得
	useUpdateEffect(() => {
		const getSearchCriterionForOffseg = async () => {
			const [dialog, offsegMasterInfo] = await getOffsegMasterInfoWithOrganizationIdHandler(
				getType,
				selectedOffsegMasterInfo.selectedOffsegOrganizationInfo.id,
			);

			if (!offsegMasterInfo) {
				setMasterInfo({ ...masterInfo, offsegCarInfoList: [], offsegDriverInfoList: [] });
				setSelectedOffsegMasterInfo(initSelectedOffsegMasterInfo);
				setDialog(dialog);
				return;
			}

			setMasterInfo({
				...masterInfo,
				offsegCarInfoList: offsegMasterInfo.offsegCarInfoList,
				offsegDriverInfoList: offsegMasterInfo.offsegDriverInfoList,
			});
		};

		getSearchCriterionForOffseg();
	}, [selectedOffsegMasterInfo.selectedOffsegOrganizationInfo.id]);
};
